import { useEffect, useState } from 'react';
import { IMAGE_URL } from '../../constants';

const useAudio = (url?: string | null): [boolean, () => void] => {
    const [audio] = useState(url ? new Audio(`${IMAGE_URL}${url}`) : null);
    const [playing, setPlaying] = useState(false);

    const toggle = () => setPlaying(!playing);

    useEffect(() => {
        if(url && audio)
            playing ? audio.play() : audio.pause();
    }, [playing]);

    useEffect(() => {
        if(url && audio)
            audio.addEventListener('ended', () => setPlaying(false));
        return () => {
            if(url && audio)
                audio.removeEventListener('ended', () => setPlaying(false));
        };
    }, []);

    if(!url)
        return [false, () => {}];

    return [playing, toggle];
};

export default useAudio;
